import I3TableItemType = ToroEnums.I3TableItemType;

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { I3AssetDown } from '../../../../../api/intelli360/models/i3-assets-down.model';
import { I3AssetWorkOrders } from '../../../../../api/intelli360/models/i3-open-work-orders.model';
import { I3MaintenanceDueAsset } from '../../../../../api/intelli360/models/i3-assets-maintenance-due.model';
import { I3OperatingStatusAsset } from '../../../../../api/intelli360/models/i3-assets-operating-status.model';
import { ToroEnums } from '../../../../../common/enumerations/toro.enums';

@Component({
    selector: 'toro-i3-table-card',
    templateUrl: './i3-table-card.component.html',
    styleUrls: ['./i3-table-card.component.less']
})
export class I3TableCardComponent {

    protected I3TableItemType = I3TableItemType;

    @Output() tableItemClick = new EventEmitter<I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset>();

    @Output() selectedAssetChange = new EventEmitter<I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset>();

    private _selectedAsset: I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset;
    @Input() set selectedAsset(value: I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset) {
        this._selectedAsset = value;
        this.isSelected = this._selectedAsset == this.asset;
    }

    private _asset: I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset;
    @Input() set asset(value: I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset) {
        if (value instanceof I3AssetDown) {
            this.itemType = I3TableItemType.AssetDown;
        } else if (value instanceof I3AssetWorkOrders) {
            this.itemType = I3TableItemType.WorkOrder;
        } else if (value instanceof I3MaintenanceDueAsset) {
            this.itemType = I3TableItemType.MaintenanceDueAsset;
        } else if (value instanceof I3OperatingStatusAsset) {
            this.itemType = I3TableItemType.OperatingStatus;
            this.setOperationalStatus(value);
        }

        this._asset = value;
    }

    get asset(): I3AssetDown | I3AssetWorkOrders | I3MaintenanceDueAsset | I3OperatingStatusAsset {
        return this._asset;
    }

    @Input() fontSizePx: number = 14;

    protected itemType: I3TableItemType;
    protected isSelected: boolean = false;
    protected operationStatus: string;
    protected opStatusColor = 'grey';

    // =========================================================================================================================================================
    // Event Handlers
    // =========================================================================================================================================================

    onCardClick() {
        this.selectedAssetChange.emit(this.asset);

        this.tableItemClick.emit(this.asset);
    }

    // =========================================================================================================================================================
    // Helper Methods
    // =========================================================================================================================================================

    private setOperationalStatus(asset: I3OperatingStatusAsset): void {
        switch (asset.operationalStatus) {
            case 'IDLE':
                this.operationStatus = 'STRINGS.IDLING';
                this.opStatusColor = '#F3D43B';
                break;
            case 'OFF':
                this.operationStatus = 'STRINGS.OFF';
                this.opStatusColor = '#646E73';
                break;
            case 'TOWING':
                this.operationStatus = 'STRINGS.TOWING';
                this.opStatusColor = '#FA9A00';
                break;
            case 'WORK':
                this.operationStatus = 'STRINGS.WORKING';
                break;
            case 'OPERATING':
                this.operationStatus = 'STRINGS.OPERATING';
                this.opStatusColor = '#18AD07';
                break;
            case 'TRANSPORT':
                this.operationStatus = 'STRINGS.TRANSPORTING';
                break;
        }
    }
}
